import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import _ from 'lodash'
import {
  withDefaults, ref, watch,
} from 'vue'

/**
 * 代表支持进行哪种输入限制的判定
 */
type InputLimitType = 'number' | 'int' | 'float' | 'uint' | 'ufloat'

interface Props {
  modelValue?: string | number
  /**
   * 限制类型，默认值：'number'
   */
  limitType?: InputLimitType
  /**
   * 为空时是否校验错误，默认值为true
   */
  emptyError?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'input-limit',
  props: {
    modelValue: null,
    limitType: { default: 'number' },
    emptyError: { type: Boolean, default: true }
  },
  emits: ['update:modelValue', 'validator'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue?: string | number, limitType: InputLimitType, emptyError: boolean }

const InputLimitFactory: {
  [name in InputLimitType]: (val: string) => boolean
} = {
  number: (val) => /^(-|\+)?\d*(\.\d*)?$/.test(val),
  int: (val) => /^\d+$/.test(val),
  float: (val) => /^(-?\d*)(\.\d*)?$/.test(val),
  uint: (val) => /^\d+$/.test(val),
  ufloat: (val) => /^\d+(\.\d*)?$/.test(val),
}


const isEmpty = ref(false)
const modelValue = ref(
  typeof props.modelValue === 'number'
    ? `${props.modelValue}`
    : props.modelValue || '',
)
const oldVal = ref(modelValue.value)

// 通过防抖动函数，避免在 table layout 是卡顿问题
const onUpdate = _.debounce((val: string): void => {
  emit('update:modelValue', val)
}, 50)

const onChange = (val: string): void => {
  if (val === '') {
    oldVal.value = val
    modelValue.value = val
    onUpdate(val)
    return
  }

  const { limitType } = props
  const matched = InputLimitFactory[limitType](val)
  if (matched) {
    oldVal.value = val
    modelValue.value = val
    onUpdate(val)
  } else {
    modelValue.value = oldVal.value
    onUpdate(oldVal.value)
  }
}

watch(modelValue, (val) => {
  isEmpty.value = !val
})

watch(isEmpty, (val) => {
  emit('validator', !isEmpty.value)
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["el-input-limit", {'is-error':__props.emptyError && isEmpty.value}])
  }, [
    _createVNode(_component_el_input, _mergeProps({
      modelValue: modelValue.value,
      onInput: onChange
    }, _ctx.$attrs), null, 16, ["modelValue"])
  ], 2))
}
}

})